export default __webpack_public_path__ + "static/media/problema-07.c661c5fc.webp";